import School from "../models/School";

export interface IndexedSchools {
    tenantNameSchoolCode: { [key: string]: School },
    tenantIdSchoolCode: { [key: string]: School }
}

export const buildIndexedSchools = (schools: School[]): IndexedSchools => {

    const indexedSchools: IndexedSchools = {
        tenantIdSchoolCode: {},
        tenantNameSchoolCode: {}
    };

    schools.forEach((school: School) => {
        const tenantNameSchoolCode = `${school.tenantName}-${school.schoolCode}`;
        indexedSchools.tenantNameSchoolCode[tenantNameSchoolCode] = school;
        indexedSchools.tenantNameSchoolCode[tenantNameSchoolCode.toLowerCase()] = school;

        const tenantIdSchoolCode = `${school.tenantId}-${school.schoolCode}`
        indexedSchools.tenantIdSchoolCode[tenantIdSchoolCode] = school;
        indexedSchools.tenantIdSchoolCode[tenantIdSchoolCode.toLowerCase()] = school;
    });
    
    return indexedSchools;
} 